import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    loading = new BehaviorSubject<boolean>(false);
    readonly loading$ = this.loading.asObservable();

    constructor() {}

    startLoading() {
        this.loading.next(true);
    }
    stopLoading() {
        this.loading.next(false);
    }
}
